import { z } from "zod";

export const EntregaObraClienteArquivoSchema = z.object({
    idEntregaObraClienteArquivo: z.number().int().optional(),
    idEntregaObra: z.number().int().positive(),
    nome: z.string().optional().nullable(),
    descricao: z.string().optional(),
    arquivo: z.instanceof(File).nullable().default(null),

    limparArquivo: z.boolean().optional().default(false),
});

export type EntregaObraClienteArquivoForm = z.infer<typeof EntregaObraClienteArquivoSchema>;

export const defaultEntregaObraClienteArquivoForm: Partial<EntregaObraClienteArquivoForm> = {
    idEntregaObra: undefined,
    nome: undefined,
    descricao: undefined,
    arquivo: null,

    limparArquivo: false,

};
